import { cloneDeep as e } from "../../../../utils/cloneDeep.js";
import { ad2bs as t } from "../calendar-carburettor/converter/index.js";
import { getStrategy as n } from "../core/libs/strategy/strategy-provider.js";
import { selectCtx as r, selectEvents as i, selectMonthViewYearLabel as a } from "../core/models/selectors/index.js";
import { useDatePickerStore as o } from "../core/models/use-date-picker-store.js";
import { Pipeline as s } from "../utilities/pipeline.js";
import { commitCtx as c } from "../core/models/store.js";
import { Button as l } from "../../../button/index.js";
import { useMemo as u } from "react";
import { jsx as d, jsxs as f } from "react/jsx-runtime";
import p from "dayjs";
// src/design/forms/datepicker/ui/month-view.tsx
var m = (t) => {
	let r = e(t);
	r.isOpen = !0;
	let i = n(r.isNepali), { next: a } = s().push(i.setGridMonths).execute({ next: r });
	return a.gridMonths;
}, h = (e) => {
	let { isNepali: n, calendarReferenceDate: r } = e.ctx, i = r || p().format("YYYY-MM-DD");
	return (n ? t(i) : i).split("-");
}, g = (e) => h(e)[0], _ = (e) => h(e)[1], v = ({ month: t, index: r, onSelection: a }) => {
	let { setState: u } = o(i), f = o(g), p = o(_), m = r + 1 === parseInt(p + "") && parseInt(f + "");
	return /* @__PURE__ */ d(l, {
		variant: "secondary",
		colorScheme: m ? "primary" : "default",
		className: "text-xs",
		onClick: () => {
			let i = r + 1;
			u(async (t, r) => {
				let a = e(t().ctx), o = n(a.isNepali);
				await s().push(o.selectMonth(i)).push(o.setGridDatesWithMeta).push(o.setMonthYearPanelData).push(o.setCalendarControllerLabels).push(c(r)).execute({ next: a });
			}), a && a(t);
		},
		children: t
	}, r);
}, y = ({ onYearClick: e }) => {
	let t = o(a), { goToYearView: n, nextYear: r, previousYear: s } = o(i);
	return /* @__PURE__ */ f("div", {
		className: "flex w-full px-2 py-1 items-center justify-between",
		children: [
			/* @__PURE__ */ d(l.IconButton, {
				size: "sm",
				variant: "ghost",
				colorScheme: "default",
				icon: "ChevronsLeft",
				"aria-label": "month-change-btn",
				onClick: s
			}),
			/* @__PURE__ */ d(l, {
				variant: "ghost",
				size: "sm",
				onClick: () => {
					n(), e?.(t);
				},
				children: t
			}),
			/* @__PURE__ */ d(l.IconButton, {
				size: "sm",
				variant: "ghost",
				colorScheme: "default",
				icon: "ChevronsRight",
				"aria-label": "month-change-btn",
				onClick: r
			})
		]
	});
}, b = ({ onSelection: e }) => {
	let t = o(r), n = u(() => m(t), [t]);
	return /* @__PURE__ */ d("div", {
		className: "px-2 pb-2",
		children: /* @__PURE__ */ d("div", {
			className: "grid grid-cols-2 gap-2",
			children: n.map((t, n) => /* @__PURE__ */ d(v, {
				month: t,
				index: n,
				onSelection: e
			}, n))
		})
	});
}, x = ({ children: e }) => e;
x.Control = y, x.Grid = b;
export { x as MonthView };

//# sourceMappingURL=month-view.js.map